export function dispatchOptionField(dispatch, form_component, value, optionFields, curStep, form_components, option = null, jumpHistory = []) {
	if (!Array.isArray(optionFields)) {
		return;
	}

	// Find current SE index
	let currentSEIndex = 0;
	let seMapping = {};
	form_components.forEach((comp, index) => {
		if (comp.format === 'SE') {
			currentSEIndex++;
			seMapping[comp._id] = currentSEIndex;
		}
	});

	const optionField = optionFields.find(optionField => optionField.fieldname === form_component.fieldname);
	
	if (optionField) {
		// Create new array by copying all existing fields
		const updatedOptionFields = [...optionFields];
		const fieldIndex = updatedOptionFields.findIndex(
			field => field.fieldname === form_component.fieldname
		);

		if (fieldIndex !== -1) {
			// For radio/select, directly use option's jump conditions
			if (form_component.input_type === 'radio' || form_component.input_type === 'select') {
				updatedOptionFields[fieldIndex] = {
					...updatedOptionFields[fieldIndex],
					value: value,
					jump_to_session: option?.jump_to_session || null,
					jump_to_se_index: option?.jump_to_session ? seMapping[option.jump_to_session] : 0,
					jump_to_seq: option?.seq || 0,
					seq: form_component.seq
				};
			}
			// For checkbox, handle multiple selections
			else if (form_component.input_type === 'checkbox') {
				const checkboxValues = value ? value.split(',') : [];
				if (checkboxValues.length > 0 && option?.jump_to_session) {
					updatedOptionFields[fieldIndex] = {
						...updatedOptionFields[fieldIndex],
						value: value,
						jump_to_session: option.jump_to_session,
						jump_to_se_index: seMapping[option.jump_to_session],
						jump_to_seq: option?.seq || 0,
						seq: form_component.seq
					};
				}
			}
		}

		dispatch({type: 'SET_OPTION_FIELDS', payload: updatedOptionFields});

		// Only calculate next step if we have a jump condition
		if (option?.jump_to_session) {
			// Check if the jump condition is to submit the form
			if (option.jump_to_session === 'submit_form') {
				const newJumpHistory = [
					...jumpHistory,
					{
						from: curStep,
						to: curStep + 1, // Adjust this if you want a different next step when submitting
						fieldname: form_component.fieldname,
						value: value,
						jump_to_session: 'submit_form'
					}
				];
				dispatch({ type: 'SET_JUMP_HISTORY', payload: newJumpHistory });
				dispatch({ type: 'SET_NEXT_STEP', payload: curStep + 1 });
				return;
			}

			const seIndex = seMapping[option.jump_to_session];
			if (seIndex) {
				// Simply append to jump history
				const newJumpHistory = [
					...jumpHistory,
					{
						from: curStep,
						to: seIndex,
						fieldname: form_component.fieldname,
						value: value,
						jump_to_session: option.jump_to_session
					}
				];
				dispatch({ type: 'SET_JUMP_HISTORY', payload: newJumpHistory });

				// Then set next step
				dispatch({ type: 'SET_NEXT_STEP', payload: seIndex });
			} else {
				dispatch({ type: 'SET_NEXT_STEP', payload: curStep + 1 });
			}
		} else {
			dispatch({ type: 'SET_NEXT_STEP', payload: curStep + 1 });
		}
	}
}

export function debug_log(...args) {
	try {
		if (typeof window !== 'undefined' && window.__FORM_DEBUG__) {
			console.log(...args);
		}
	} catch (e) {}
}

export function openAlert(message, t, iframe = false) {
	const position = iframe ? 'bottom' : 'center';

	// Safely apply the translation function
	let translatedMessage = message;
	let translatedButton = '確定';
	
	if (typeof t === 'function') {
		try {
			translatedMessage = t(message);
			translatedButton = t('確定');
		} catch (e) {
			console.error('Translation error in openAlert:', e);
			// Fall back to original message if translation fails
		}
	}

	const SwalRef = typeof window !== 'undefined' ? (window.Swal || window.swal) : null;
	if (!SwalRef || typeof SwalRef.fire !== 'function') {
		window.alert(translatedMessage);
		return;
	}

	SwalRef.fire({
        html: `<p class="text-center">${translatedMessage}</p>`,
        icon: "warning",
        buttonsStyling: false,
        showCancelButton: false,
        confirmButtonText: translatedButton,
        returnFocus: false,
        customClass: {
            confirmButton: "btn btn-primary",
            popup: 'swal-bottom-offset' // for iframe use, as they cannot auto-scroll
        },
        position: position 
    });

	return;
}

/**
 * Initialize global openAlert function if not defined
 */
export const initializeGlobalOpenAlert = () => {
	// Check if the openAlert function exists
	if (typeof window.openAlert !== 'function') {
		
		// Create a fallback implementation using our openAlert function
		window.openAlert = (message) => {
            if (window.Swal) {
                openAlert(message, (msg) => msg); // Use a basic translator function
            } else {
                // Fallback if Swal is not available
                alert(message);
            }
        };
		
		return true;
	}
	
	return false;
};

export function getUserFieldValue(fieldname, userData) {
	// Determine the user field value for custom profile fields
	let userFieldValue;
	const customFieldMatch = fieldname.match(/^profile_custom_fields\[(.+)\]$/);
	if (customFieldMatch && userData && userData.profile_custom_fields) {
		userFieldValue = userData.profile_custom_fields[customFieldMatch[1]];
	} else if (userData) {
		userFieldValue = userData[fieldname];
	}

	return userFieldValue;
}
